import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { AuthGuardService as AuthGuard } from './services/auth/auth-guard.service';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { TranslateModule } from '@ngx-translate/core';
type PathMatch = "full" | "prefix" | undefined;

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./login/login.module').then((m) => m.LoginModule) },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      // user UI
      /*
      {
        path: '',
        canActivate: [DashboardGuardService],
        children: [],
        pathMatch: 'full' as PathMatch
      },*/
      {
        path: 'dashboard',
        loadChildren: () => import('./user/dashboard/dashboard.module').then((m) => m.DashboardModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'persona/:id',
        loadChildren: () => import('./user/person/person.module').then((m) => m.PersonModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'organization-chart',
        loadChildren: () => import('./organization-chart/organization-chart.module').then((m) => m.OrganizationChartModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'reports',
        loadChildren: () => import('./user/reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [AuthGuard],
      },
      // admin UI
      {
        path: 'administration',
        loadChildren: () => import('./administration/administration.module').then((m) => m.AdministrationModule),
        canActivate: [AuthGuard],
      },
      { path: '**', redirectTo: 'dashboard', pathMatch:  'full' as PathMatch},
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {}),
    InlineSVGModule.forRoot(),
    TranslateModule.forRoot()
  ],
  exports: [RouterModule,TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppRoutingModule {}
